import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Group, ActionIcon, Text, Highlight, Loader, Menu } from "@mantine/core";
import { IconDotsVertical, IconTrash, IconPencil, IconStar, IconStarFilled } from "@tabler/icons-react";
import { useIntl } from "react-intl";
import { useState } from "react";
const activeStyles = {
    background: "light-dark(#EDEDEB, #54534C)",
    color: "light-dark(black, white)",
    borderRadius: "8px",
};
const defaultStyles = {
    borderRadius: "8px",
};
const itemTextStyle = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    wordBreak: "break-all",
};
export const ChatListItem = ({ chat, highlight, width, active, onDeleteChat, onSwitchChat, onRenameChat, onStarChat }) => {
    const intl = useIntl();
    const [hover, setHover] = useState(false);
    const { id, summary, status, starred, } = chat;
    const pending = status === "pending";
    const deleteLabel = intl.formatMessage({
        defaultMessage: "Delete",
        id: "menu.deleteChat",
    });
    const renameLabel = intl.formatMessage({
        defaultMessage: "Rename",
        id: "menu.renameChat",
    });
    const starLabel = intl.formatMessage({
        defaultMessage: "Star",
        id: "menu.starChat",
    });
    const unstarLabel = intl.formatMessage({
        defaultMessage: "Unstar",
        id: "menu.unstarChat",
    });
    const styles = active || hover
        ? activeStyles
        : defaultStyles;
    const textWidth = active || hover
        ? width - 32
        : width;
    const textWithWhilePending = pending
        ? textWidth - 32
        : textWidth;
    return (_jsxs(Group, { py: "6px", gap: "0px", h: "40px", w: width, align: "center", style: styles, onMouseEnter: () => { setHover(true); }, onMouseLeave: () => { setHover(false); }, onClick: (event) => {
            event.stopPropagation();
            onSwitchChat(id);
        }, children: [pending && _jsx(Loader, { size: "xs", px: "12px", color: "gray" }), _jsx(Text, { size: "sm", px: "12px", style: itemTextStyle, w: textWithWhilePending, component: "span", children: _jsx(Highlight, { highlight: highlight, lh: "20px", children: summary }) }), (hover || active) && (_jsxs(Menu, { shadow: "md", width: 160, position: "bottom-end", children: [_jsx(Menu.Target, { children: _jsx(ActionIcon, { variant: "subtle", color: "gray", onClick: (event) => {
                                event.stopPropagation();
                            }, children: _jsx(IconDotsVertical, { size: 16 }) }) }), _jsxs(Menu.Dropdown, { children: [_jsx(Menu.Item, { leftSection: starred ? _jsx(IconStarFilled, { size: 14 }) : _jsx(IconStar, { size: 14 }), onClick: (event) => {
                                    event.stopPropagation();
                                    onStarChat(id, !starred);
                                }, children: starred ? unstarLabel : starLabel }), _jsx(Menu.Item, { leftSection: _jsx(IconPencil, { size: 14 }), onClick: (event) => {
                                    event.stopPropagation();
                                    onRenameChat(id, summary);
                                }, children: renameLabel }), _jsx(Menu.Divider, {}), _jsx(Menu.Item, { color: "red", leftSection: _jsx(IconTrash, { size: 14 }), onClick: (event) => {
                                    event.stopPropagation();
                                    onDeleteChat(id);
                                }, children: deleteLabel })] })] }))] }, chat.id));
};
